import { useQuery } from '@tanstack/vue-query';
import { computed, unref, type MaybeRef } from 'vue';
import { useAuthStore } from '@/store/auth';

export type DeveloperContactRow = {
  displayName: string;
  role: string;
  phone?: string | null;
  email?: string | null;
  whatsapp?: string | null;
  avatarUrl?: string | null;
};

type DeveloperContactsResponse = {
  success: boolean;
  data: { managers: DeveloperContactRow[] };
};

export const useDeveloperContactsQuery = (developerName: MaybeRef<string | null | undefined>) => {
  const authStore = useAuthStore();

  return useQuery({
    queryKey: ['developer-contacts', computed(() => unref(developerName) || '')],
    queryFn: () =>
      $fetch<DeveloperContactsResponse>(
        `/api/developers/by-name/${encodeURIComponent(unref(developerName) as string)}/account-managers`,
        {
          headers: authStore.token ? { Authorization: `Bearer ${authStore.token}` } : undefined,
        },
      ).then((r) => r.data),
    enabled: computed(() => !!unref(developerName)),
    staleTime: 5 * 60 * 1000,
  });
};
